import { VITE_SSL } from "../constants/variables";
import UniversalCookies, {
  CookieGetOptions,
  CookieSetOptions,
} from "universal-cookie";

const Cookies = () => {
  const cookies = new UniversalCookies();
  const cookieSetOptions: CookieSetOptions = {
    secure: VITE_SSL === "true",
    path: "/",
  };

  const cookieGetOptions: CookieGetOptions = {
    // doNotParse: true,
  };

  const setItem = (key: string, value: string) =>
    cookies.set(key, value, cookieSetOptions);

  const getItem = (key: string): string => cookies.get(key, cookieGetOptions);

  const removeItem = (key: string) => cookies.remove(key, cookieSetOptions);

  return {
    setItem,
    getItem,
    removeItem,
  };
};

export default Cookies();
